import { LastMoveOrders } from "../Components/index.js";

export default [
    {
        path: "/hr/last-move-orders",
        component: LastMoveOrders,
        name: "report-date-wise-move-orders",
        meta: {
            requiresAuth: true,
        },
    },
];
